import { render, staticRenderFns } from "./on-call.vue?vue&type=template&id=f5e7ef42&"
import script from "./on-call.vue?vue&type=script&lang=js&"
export * from "./on-call.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports